import { LogoutOutlined } from '@ant-design/icons';
import { ACTION_MENU_USER } from 'constants/actionMenuUser';

export const getLogoutMenuItem = (t: (key: string) => string, className?: string) => {
  return {
    key: ACTION_MENU_USER.LOGOUT,
    label: <span className={className}>{t('common.header.user.logout')}</span>,
    icon: <LogoutOutlined />
  };
};
